import { all } from "redux-saga/effects";
import { sagas as rewards } from "../modules/rewards";

export function* rootSaga() {
  yield all([rewards.watchFetchRewardsAccounts()]);
}
